/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import ITemplateModel from 'apmui/master/Model';
import { IFormConfiguration } from 'apmui/components/form/Model';
import PageType from 'apmui/page/PageType';

const FORM_ID = 'hidden_form';
const FIELD_NAME = 'choice';

interface IDecisionBoxOption {
    image: string;
    message: string;
    result: number;
}

interface IDecisionBoxModel extends ITemplateModel {
    /* Page type tag */
    pageType: PageType.DECISION_BOX;

    /* Decision box config */
    [PageType.DECISION_BOX]: {
        form?: IFormConfiguration;
        config: {
            title: string;
            options: IDecisionBoxOption[];
        };
        images: {
            image00: string;
            image01: string;
            image02: string;
            image03: string;
            image04: string;
            image05: string;
            image06: string;
            image07: string;
            image08: string;
            image09: string;
        };
    };
}

export { IDecisionBoxModel as default, IDecisionBoxOption, FORM_ID, FIELD_NAME };
